import React from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { to: "/admin", label: "Dashboard" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/devices", label: "Devices" },
  { to: "/admin/faqs", label: "FAQs" },
  { to: "/admin/stories", label: "Stories" },
  { to: "/admin/home-modules", label: "Home" },
  { to: "/admin/pricing-plans", label: "Pricing" },
  { to: "/admin/future", label: "Roadmap" },
  { to: "/admin/rules", label: "Rules" },
  { to: "/admin/contact", label: "Contact" },
  { to: "/admin/contact-responses", label: "Requests" },
  { to: "/admin/notifications", label: "Notify" },
];

export default function AdminNav() {
  const { pathname } = useLocation();
  return (
    <div className="w-full min-w-0 overflow-x-auto pb-1">
      <div className="flex gap-2 flex-nowrap w-max max-w-full sm:flex-wrap sm:w-auto">
      {links.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          className={`px-4 py-2 rounded-full text-sm border ${
            pathname === l.to ? "bg-card border-accent text-accent" : "border-border text-muted-foreground"
          }`}
        >
          {l.label}
        </Link>
      ))}
      </div>
    </div>
  );
}

